import { createSvgIcon } from "./create-svg-icon";

export const CircledQuestion = createSvgIcon(
  <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM5.496 6.033H6.321C6.459 6.033 6.569 5.92 6.587 5.783C6.677 5.127 7.127 4.649 7.929 4.649C8.615 4.649 9.243 4.992 9.243 5.817C9.243 6.452 8.869 6.744 8.278 7.188C7.605 7.677 7.072 8.248 7.11 9.175L7.113 9.392C7.11518 9.52851 7.22648 9.63802 7.363 9.638H8.174C8.31207 9.638 8.424 9.52607 8.424 9.388V9.283C8.424 8.565 8.697 8.356 9.434 7.797C10.043 7.334 10.678 6.82 10.678 5.741C10.678 4.23 9.402 3.5 8.005 3.5C6.738 3.5 5.35 4.09 5.255 5.786C5.25223 5.85127 5.27653 5.91479 5.32216 5.96155C5.36778 6.00831 5.43068 6.03416 5.496 6.033ZM8.85 11.549C8.85 12.082 8.431 12.476 7.821 12.476H7.822C7.237 12.476 6.812 12.082 6.812 11.549C6.812 10.997 7.237 10.609 7.821 10.609C8.43 10.609 8.85 10.997 8.85 11.549Z"
      fill="currentColor"
    />
  </svg>,
);
